export default "__VITE_ASSET__BumVpHEs__"